<template>
  <!-- 骨架屏 -->
  <div v-if="pageLoading" style="padding-top: 80px">
    <van-skeleton title :row="5" />
    <van-skeleton title :row="5" style="margin-top: 30px" />
  </div>
  <div v-else class="home">
    <!-- 记录规则分享 -->
    <div class="record-rule">
      <div @click="recordVisible = true">记录</div>
      <div @click="ruleVisible = true">规则</div>
    </div>
    <!-- 已报名提示 -->
    <div class="enrolled-status">
      <!-- xib.enhance.signUpTextApril=已报名4月活动（待领取奖励）==>图片1
           xib.enhance.signUpTextMay=已报名5月活动（待领取奖励）==>图片2
           xib.enhance.signUpTextJune=已报名6月活动（待领取奖励）==>图片3
           xib.enhance.signUpTextNotParticipated=未参与==>图片4
           xib.enhance.signUpTextReceived=已领取奖励==>图片5
           xib.enhance.signUpTextNotReach=未达标==>图片6
           xib.enhance.signUpTextNotReach=立即报名，可点击报名==>图片8
           
      -->
      <img
        :src="statusImageMap[+currentSignUpButtonText]"
        v-show="currentSignUpButtonText"
        :class="{ 'clickable': currentSignUpButtonSelectable }"
        @click="handleSignUp"
      />
    </div>
    <!-- 内容容器：包含时间、期数、奖励 -->
    <div class="content-wrapper">
      <!-- 领奖时间 -->
      <div class="time-section">
        <div class="time-text">
          {{ activityList?.[tabActive]?.receiveStartTime }} -
          {{ activityList?.[tabActive]?.receiveEndTime }}
        </div>
        <div class="time-tips">每月都需要进行报名</div>
      </div>

      <!-- 三期切换标签 -->
      <div class="period-tabs">
        <div
          :class="['tab-item', { active: tabActive === index }]"
          v-for="(item, index) in tabItems"
          :key="index"
          @click="tabActive = index"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="tips">
        综合贡献值较上月提升达相应档位，即可在档位奖励中任选其一，先到先得。
      </div>

      <!-- 奖励列表 -->
      <div class="reward-list">
        <!-- 第一行 -->
        <div
          :class="['reward-item', 'reward-item-' + (index + 1)]"
          v-for="(item, index) in activityList?.[tabActive]?.levelButtons"
          :key="index"
        >
          <van-button
            class="btn-receive"
            :disabled="!item.selectable"
            @click="openRewardModal(item)"
          >
            {{ item.buttonText }}
          </van-button>
        </div>
      </div>
    </div>

    <!-- 弹框组件 -->
    <toastModal
      :visible="toastVisible"
      :message="toastMessage"
      @confirm="toastVisible = false"
    />
    <ruleModal :visible="ruleVisible" @confirm="ruleVisible = false" />
    <recordModal :visible="recordVisible" @confirm="recordVisible = false" />
    <rewardModal
      :visible="rewardVisible"
      :rewardParms="rewardParms"
      @confirm=";(rewardVisible = false), loadActivityDetail()"
    />
  </div>
</template>

<script>
import toastModal from './components/toastModal.vue'
import recordModal from './components/recordModal.vue'
import ruleModal from './components/ruleModal.vue'
import rewardModal from './components/rewardModal.vue'
import { login, getActivityDetail, signUp } from '@/api/xibPromotionGift'
import { preloadAllImages } from './components/preloadImages.js'
export default {
  components: { toastModal, ruleModal, recordModal, rewardModal },
  data() {
    return {
      tabItems: [{ text: '第一期' }, { text: '第二期' }, { text: '第三期' }],
      tabActive: 0,
      activityList: [], // 奖励列表
      toastVisible: false,
      toastMessage: '',
      ruleVisible: false,
      recordVisible: false,
      rewardVisible: false,
      openId: undefined,
      appId: undefined,
      pageLoading: true, // 页面加载状态
      // 预先映射按钮状态图片
      statusImageMap: {
        1: require('@/assets/imgs/promotionGift/btnStatus1.png'),
        2: require('@/assets/imgs/promotionGift/btnStatus2.png'),
        3: require('@/assets/imgs/promotionGift/btnStatus3.png'),
        4: require('@/assets/imgs/promotionGift/btnStatus4.png'),
        5: require('@/assets/imgs/promotionGift/btnStatus5.png'),
        6: require('@/assets/imgs/promotionGift/btnStatus6.png'),
        7: require('@/assets/imgs/promotionGift/btnStatus7.png'),
        8: require('@/assets/imgs/promotionGift/btnStatus8.png'),
        9: require('@/assets/imgs/promotionGift/btnStatus9.png'),
        10: require('@/assets/imgs/promotionGift/btnStatus10.png'),
        11: require('@/assets/imgs/promotionGift/btnStatus11.png'),
        12: require('@/assets/imgs/promotionGift/btnStatus12.png'),
      },
      rewardParms: {} // 领取权益参数
    }
  },
  computed: {
    /** 当前期数对应的报名状态图（与 activityList[tabActive].signUpButtonText 一致） */
    currentSignUpButtonText() {
      return this.activityList?.[this.tabActive]?.signUpButtonText
    },
    /** 当前期数对应的报名按钮是否可点击 */
    currentSignUpButtonSelectable() {
      return this.activityList?.[this.tabActive]?.signUpButtonSelectable
    }
  },
  async mounted() {
    await preloadAllImages()
    this.pageLoading = false
    // this.doLogin()
    this.loadActivityDetail()
  },
  methods: {
    async doLogin() {
      try {
        // 已登录就不在登录
        if(sessionStorage.getItem('xiameBankPromotionGiftToken')) {
          await this.loadActivityDetail()
          return
        }
        const { token } = this.$route.query
        const { code, data } = await login({ token })
        if (code !== 0) return
        if (data.isSign) {
          // 初次报名
          this.showEnrolledToast('<div>恭喜你<b>报名成功!</b></div>')
        }
        sessionStorage.setItem('xiameBankPromotionGiftToken', data.token)
        await this.loadActivityDetail()
      } catch (error) {
        console.log(error)
      }
    },
    async loadActivityDetail() {
      try {
        const { data } = await getActivityDetail()
        if (data.isSign) {
          // 初次报名
          this.showEnrolledToast('<div>恭喜你<b>报名成功!</b></div>')
        }
        this.activityList = data.activityList || []
        this.appId = data.appId
        this.openId = data.openId
      } catch (error) {
        console.log(error)
      }
    },
    // 领取权益
    openRewardModal(val) {
      this.rewardParms = {
        gradeNum: val.gradeNum,
        openId: this.openId,
        appId: this.appId
      }
      this.rewardVisible = true
    },
    showEnrolledToast(text) {
      // this.toastMessage =
      //   '<div style="text-align: justify">您已报名1月活动，请在<b style="font-weight: bold">2026年02月05日-2026年02月28日</b>时间内进行奖励领取</div>'
      // this.toastMessage = '<div>用户已领取过权益</div>'
      // this.toastMessage = '<div>用户不符合领取资格</div>'
      // this.toastMessage = '<div>领取时间未开始</div>'
      // this.toastMessage = '<div>恭喜你<b>报名成功!</b></div>'
      this.toastMessage = text
      this.toastVisible = true
    },
    async handleSignUp() {
      if (!this.currentSignUpButtonSelectable) {
        return
      }
      try {
        const { code, data } = await signUp()
        if (code !== 0) return
        if (data) {
          this.showEnrolledToast('<div>恭喜你<b>报名成功!</b></div>')
          await this.loadActivityDetail()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #6f4ab0;
  background-image: url('~@/assets/imgs/promotionGift/homeBg.png');
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  .enrolled-status {
    width: 260px;
    text-align: center;
    margin: 410px auto 0;
    img {
      width: 100%;
      height: auto;
      &.clickable {
        cursor: pointer;
        transition: transform 0.2s;
        &:active {
          transform: scale(0.95);
        }
      }
    }
  }
  .record-rule {
    position: absolute;
    top: 90px;
    right: 5px;
    width: 37px;
    font-size: 12px;
    color: white;
    cursor: pointer;
    div {
      width: 37px;
      height: 37px;
      line-height: 37px;
      background: #605061;
      border-radius: 13px;
      text-align: center;
      margin-bottom: 12px;
    }
  }
  .content-wrapper {
    width: 350px;
    padding: 42px 12px 20px;
    box-sizing: border-box;
    background-color: #f6f0fb;
    // background-color: rgba(236, 226, 247, 1);
    border-radius: 20px;
    margin: 0 auto 17px;
    background-image: url('~@/assets/imgs/promotionGift/homeBg2.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top;
    position: relative;
    .time-section {
      position: absolute;
      top: 6px;
      left: 134px;
      .time-text {
        font-size: 14px;
        color: white;
        font-weight: bold;
      }
      .time-tips {
        font-size: 12px;
        color: #ffeb00;
        padding-top: 2px;
      }
    }

    .period-tabs {
      display: flex;
      justify-content: space-around;
      .tab-item {
        width: 93px;
        height: 39px;
        padding-top: 9px;
        box-sizing: border-box;
        text-align: center;
        background: url('~@/assets/imgs/promotionGift/tabItem.png');
        background-size: 100% 100%;
        font-size: 14px;
        color: #1c0960;
        cursor: pointer;
        transition: all 0.3s;
        &.active {
          background: url('~@/assets/imgs/promotionGift/tabItemActive.png');
          background-size: 100% 100%;
          color: #ffffff;
        }
      }
    }
    .tips {
      color: #855da6;
      line-height: 15px;
      font-size: 12px;
      padding: 9px 10px 4px;
    }
    .reward-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      .reward-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 160px;
        height: 143px;
        background-size: 100% 100%;
        position: relative;
        .btn-receive {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 12px;
          border-radius: 15px;
          font-size: 13px;
          cursor: pointer;
          width: 90px;
          height: 30px;
          padding: 0 5px;
          color: #fff;
          background: linear-gradient(0deg, #ad4aff, #da8afe);
        }
        // 各档位背景图（index 从 1 开始）
        &.reward-item-1 {
          background-image: url('~@/assets/imgs/promotionGift/第1档.png');
        }
        &.reward-item-2 {
          background-image: url('~@/assets/imgs/promotionGift/第2档.png');
        }
        &.reward-item-3 {
          background-image: url('~@/assets/imgs/promotionGift/第3档.png');
        }
        &.reward-item-4 {
          background-image: url('~@/assets/imgs/promotionGift/第4档.png');
        }
        &.reward-item-5 {
          background-image: url('~@/assets/imgs/promotionGift/第5档.png');
        }
        &.reward-item-6 {
          background-image: url('~@/assets/imgs/promotionGift/第6档.png');
        }
      }
    }
  }
}
</style>
